module.exports = __webpack_public_path__ + "img/hzjd2.271c8d25.jpg";